import { useRef, useEffect } from 'react';
import { HOLD_INTERVAL_MS } from '../mvp/App';
/**
 * Repeats fn() every HOLD_INTERVAL_MS while key is held.
 * The first call fires immediately.
 */
export default function useKeyHold(key, fn) {

    const timer = useRef(null);
    const lastEvent = useRef(Date.now());

    useEffect(() => {
    const id = setInterval(() => {
        if (timer.current && Date.now() - lastEvent.current > HOLD_INTERVAL_MS + 100) {
        clearInterval(timer.current);
        timer.current = null;
        }
    }, HOLD_INTERVAL_MS);
    return () => clearInterval(id);
    }, []);

    useEffect(() => {
        const down = e => {
            if (e.key !== key) return;
            e.preventDefault();
            if (!timer.current) {
                fn();
                timer.current = setInterval(fn, HOLD_INTERVAL_MS);
            }
            lastEvent.current = Date.now();
        };


    const up = e => {
      if (e.key !== key || !timer.current) return;
      clearInterval(timer.current);
      timer.current = null;
    };

    document.addEventListener('keydown', down, true);
    document.addEventListener('keyup',   up,   true);
    document.addEventListener('tvremote', down, true);
    return () => {
      clearInterval(timer.current);
      document.removeEventListener('keydown', down, true);
      document.removeEventListener('keyup',   up,   true);
      document.removeEventListener('tvremote', down, true);
    };
  }, [key, fn]);
}